import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toggleSMLPricingModal } from '../../../../redux/slices/appInfo/slice';
import { useCustomerPortalUrl } from '../../../common/hooks/useCustomerPortalUrl';
import { useIsNativeEmbed } from '../../navigation/hooks/useIsNativeEmbed';

export type BrowseUpgradeMode = 'owner' | 'member' | 'native';

/**
 * Who sees which upgrade path (design b5, b6). A member sees the owner note, the native web view the
 * app note (App Store 3.1.1), the owner the plans: the plan window on Free and the trial, the Stripe
 * portal on a paid plan.
 */
export function useBrowseUpgradeAction(params: { isOwner: boolean; paidPlan: boolean; enabled: boolean }) {
  const dispatch = useDispatch();
  const isNativeEmbed = useIsNativeEmbed();
  let mode: BrowseUpgradeMode = 'owner';
  if (isNativeEmbed) {
    mode = 'native';
  } else if (!params.isOwner) {
    mode = 'member';
  }
  const { portalUrl } = useCustomerPortalUrl({ enabled: params.enabled && mode === 'owner' && params.paidPlan });

  const openPlans = useCallback(() => {
    dispatch(toggleSMLPricingModal({ shouldShow: true }));
  }, [dispatch]);

  return { mode, openPlans, portalUrl: params.paidPlan ? portalUrl : null };
}
